<template>
  <div>
    <header class="header">
      <nav class="header_con">
        <div class="hd_top">
          <div class="logo"></div>
        </div>
      </nav>
    </header>
    <section class="sub_container"> 
      <div class="partner-list">
        <div v-for="(partner, index) in partnerList" :key="index" class="partner-item">
          <div class="partner-name">{{partner.partnerName}}</div>
          <div class="partner-ceo-phone">
              <span>실무자: {{partner.contactName}}</span>
              <span>{{partner.phoneNumber}}</span>
          </div>
          <div class="partner-address">{{partner.address}} {{partner.addressDetail}}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import '@/assets/css/login.css'
import { EventBus } from "@/modules/event-bus"

export default {
  name: 'InsurancePartnerList',
  components: { },
  data: () => ({
    param: {},
    partnerList: []
  }),
  mounted() {
    EventBus.$off();

    Vue.httpClient
    .get('/common/insurance/partner/list')
    .then((response) => {
      if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
        console.log(response);
        this.partnerList = response.data.result;
      } 
    })
  }
}
</script>

<style scoped>
  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
  }
  
  body {
      /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; */
      background-color: #f5f5f5;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
  }
  
  .container {
      width: 100%;
      max-width: 380px;
      background-color: white;
      border-radius: 0;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      overflow: hidden;
      height: 100vh;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
  }
  
  .header {
      background-color: white;
      border-bottom: 1px solid #eee;
      position: sticky;
      top: 0;
      z-index: 100;
  }
  
  .title {
      font-size: 20px;
      color: #333;
      font-weight: 600;
  }
  
  .partner-list {
      padding: 0;
      overflow-y: auto;
      flex: 1;
  }
  
  .partner-item {
      padding: 16px 20px;
      border-bottom: 1px solid #eee;
  }
  
  .partner-item:last-child {
      border-bottom: none;
  }
  
  .partner-name {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      margin-bottom: 4px;
  }
  
  .partner-ceo-phone {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #666;
      margin-bottom: 4px;
  }
  
  .partner-address {
      font-size: 13px;
      color: #888;
      line-height: 1.3;
  }
</style>



// WEBPACK FOOTER //
// src/views/insurance/InsurancePartnerList.vue